import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { LoyaltyCardsEffects } from './loyalty-cards.effects';
import { ILoyaltyCardsFeature } from './loyalty-cards.feature.state';
import { LoyaltyCardsReducer } from './loyalty-cards.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ILoyaltyCardsFeature>('LoyaltyCardsFeature'), LoyaltyCardsReducer),
    EffectsModule.forFeature([LoyaltyCardsEffects]),
  ],
})
export class LoyaltyCardStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: LoyaltyCardStateModule
  ) {
    if (parentModule) {
      throw new Error('LoyaltyCardsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
